import { Antrag } from '../../types';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maxSizeExceeded',
  standalone: true,
})
export class MaxSizeExceededPipe implements PipeTransform {
  public async transform(
    antrag: Antrag,
    maximumSize: number,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    justSomethingToTrickChangeDetection: number,
  ): Promise<boolean> {
    const currentSize = await antrag.getSizeInBytes();
    return maximumSize < currentSize / 1024 / 1024;
  }
}
